import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateCustomerDto } from './create-customer.dto';

/**
 * Update customer DTO
 */
export class UpdateCustomerDto extends CreateCustomerDto {
	@TransformInt()
	id!: number;
}
